import React from 'react';
import { FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa';

interface RatingProps {
  value: number;
  reviews: number;
  color?: string;
  size?: string;
  textColor?: string;
  textSize?: string;
  showValue?: boolean;
  showReviews?: boolean;
}

const Rating: React.FC<RatingProps> = ({
  value,
  reviews,
  color = 'text-black',
  textColor = 'text-black',
  showValue = false,
  showReviews = true,
  size = 'size-16',
  textSize = 'text-14',
}) => {
  const fullStars = Math.floor(value);
  const halfStar = value % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="flex items-baseline gap-1 leading-none">
      {showValue && <span className={`pr-2 font-bold ${textSize} ${textColor} leading-none`}>{value}</span>}
      {[...Array(fullStars)].map((_, index) => (
        <FaStar key={index} className={`${size} ${color} pt-2`} />
      ))}
      {halfStar && <FaStarHalfAlt className={`${size} ${color} pt-2`} />}
      {[...Array(emptyStars)].map((_, index) => (
        <FaRegStar key={index} className={`${size} ${color} pt-2`} />
      ))}

      {showReviews && (
        <span className={`pl-1 ${textSize} ${textColor} leading-none`}>
          {reviews}
          {' reviews'}
        </span>
      )}
    </div>
  );
};

export default Rating;
